import { Fragment } from "react";
import { Route, Routes, Navigate } from 'react-router-dom';
import { checkAuth } from "../../hooks/actions/sessionActions";
import Home from "../../pages/Home/Home";
import Units from '../../pages/Units/Units';
import Login from '../../pages/Login/Login';
import Register from '../../pages/Register/Register';
import Configuracoes from '../../pages/Configuracoes/Configuracoes';
import InitConfig from '../../pages/ConfigOn/InitConfig/InitConfig';
import Empresa from '../../pages/Empresa/Empresa';
import UnitsDetails from '../../pages/UnitsDetails/UnitsDetails';
import MercadoFinanceiro from '../../pages/MercadoFinanceiro/MercadoFinanceiro';
import Relatorios from '../../pages/Relatorios/Relatorios';
import UnitsMembersEdit from '../../pages/UnitsMembers/UnitsMembersEdit';
import UnitsMembers from '../../pages/UnitsMembers/UnitsMembers';
import Termos from "../../pages/Termos/Termos";
import Logout from "../../pages/Logout/Logout";
import Notification from "../../pages/Notification/Notification";
import Alarm from "../../pages/Alarm/Alarm";
import SupportUser from "../../pages/SupportUser/SupportUser";
import SilosBag from "../../pages/SilosBag/SilosBag";
import Dryer from "../../pages/Dryer/Dryer";
import DryerDetail from "../../pages/DryerDetail/DryerDetail";
import PrivacyMe from "../../pages/PrivacyMe/PrivacyMe";
import Sementeira from "../../pages/Sementeira/Sementeira";
import AccessId from "../../pages/AccessId/AccessId";
import Rotation from "../../pages/Rotation/Rotation";
import DashboardEquipments from "../../pages/DashboardEquipments/DashboardEquipments";
import DashboardCompany from "../../pages/DashboardCompany/DashboardCompany";

const PrivateRoute = ({ Item }) => {
    const session = checkAuth();
    return session ? <Item /> : <Login />;
};

const AppRoutes = () => {
    return (
        <Fragment>
            <Routes>
                <Route path="/home" element={<PrivateRoute Item={Home} />} />
                <Route path="/units" element={<PrivateRoute Item={Units} />} />
                <Route path="/relatorio" element={<PrivateRoute Item={Relatorios} />} />
                <Route path="/silos-bag" element={<PrivateRoute Item={SilosBag} />} />
                <Route path="/dryer" element={<PrivateRoute Item={Dryer} />} />
                <Route path="/dryer/detail/:id" element={<PrivateRoute Item={DryerDetail} />} />
                <Route path="/configuracoes" element={<PrivateRoute Item={Configuracoes} />} />
                <Route path="/notification" element={<PrivateRoute Item={Notification} />} />
                <Route path="/alarm" element={<PrivateRoute Item={Alarm} />} />
                <Route path="/rotation" element={<PrivateRoute Item={Rotation} />} />
                <Route path="/empresa" element={<PrivateRoute Item={Empresa} />} />
                <Route path="/dashboard-equipments" element={<PrivateRoute Item={DashboardEquipments} />} />
                <Route path="/dashboard-company" element={<PrivateRoute Item={DashboardCompany} />} />
                <Route path="/config/equipament/:id" element={<PrivateRoute Item={InitConfig} />} />
                <Route path="/units/details/:id" element={<PrivateRoute Item={UnitsDetails} />} />
                <Route path="/units/membros/:id" element={<PrivateRoute Item={UnitsMembers} />} />
                <Route path="/units/membros-editar/:id" element={<PrivateRoute Item={UnitsMembersEdit} />} />
                <Route path="/mercadofinanceiro" element={<PrivateRoute Item={MercadoFinanceiro} />} />
                <Route path="/support-user" element={<PrivateRoute Item={SupportUser} />} />

                <Route path="/" element={<Login />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/registrar" element={<Register />} />
                <Route path="/termos-de-uso" element={<Termos />} />
                <Route path="/privacy/me" element={<PrivacyMe />} />
                <Route path="/telemetria/:id" element={<AccessId />} />

                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Fragment>
    );
};

export default AppRoutes;
